(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-10"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.variants-buttons').forEach(button => {
    button.addEventListener('click', () => {
      document
        .querySelectorAll('.variants-buttons')
        .forEach(b => b.classList.remove('active-variant'));

      button.classList.add('active-variant');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-product-11"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.variants-buttons').forEach(button => {
    button.addEventListener('click', () => {
      document
        .querySelectorAll('.variants-buttons')
        .forEach(b => b.classList.remove('active-variant'));

      button.classList.add('active-variant');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
